import type { Pair } from '../messages';

/** The sign-in and sign-up forms. Labels stay short: the field sits above them in a narrow card. */
export const auth = {
  'auth.login': ['Вход', 'Sign in'],
  'auth.identifier': ['Email или имя пользователя', 'Email or username'],
  'auth.password': ['Пароль', 'Password'],
  'auth.checking': ['Проверяем…', 'Checking…'],
  'auth.noAccount': ['Ещё нет аккаунта?', 'No account yet?'],
  'auth.create': ['Создать', 'Create one'],
  'auth.register': ['Новая библиотека', 'A new library'],
  'auth.displayName': ['Как вас называть', 'What to call you'],
  'auth.displayNameHint': [
    'Необязательно — по умолчанию совпадёт с именем пользователя.',
    'Optional — falls back to your username.',
  ],
  'auth.username': ['Имя пользователя', 'Username'],
  'auth.usernameHint': [
    'Латиница, цифры, дефис или подчёркивание. 3–30 символов.',
    'Latin letters, digits, hyphen or underscore. 3–30 characters.',
  ],
  'auth.email': ['Email', 'Email'],
  'auth.passwordHint': ['Минимум 8 символов.', 'At least 8 characters.'],
  'auth.creating': ['Создаём…', 'Creating…'],
  'auth.haveAccount': ['Уже есть аккаунт?', 'Already have an account?'],
  'auth.language': ['Ещё один язык', 'Another language'],
} satisfies Record<string, Pair>;
